import { render, staticRenderFns } from "./V2Actions.vue?vue&type=template&id=49a87d4d&scoped=true&"
import script from "./V2Actions.vue?vue&type=script&lang=js&"
export * from "./V2Actions.vue?vue&type=script&lang=js&"
import style0 from "./V2Actions.vue?vue&type=style&index=0&id=49a87d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a87d4d",
  null
  
)

export default component.exports